import React from "react";

import { Button, DatePicker, Input } from "../../components";
import { Globals } from "../../utils";
import moment from "moment";

const initialForm = {
  search: '',
  since: '',
  until: '',
};

class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        user_id: Globals.getUserId(props.user),
        ...initialForm,
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
    };
  }

  handleChange = (value, target) => {
    this.setState(s => ({ form: { ...s.form, [target]: value }}));
  };

  onSubmit = (emitter) => {
    emitter.preventDefault();

    const { form } = this.state;

    const since = form.since ? moment(form.since).format('YYYY-MM-DD') : '';
    const until = form.until ? moment(form.until).format('YYYY-MM-DD') : '';

    this.props.submitted({ ...form, since, until });
  }

  reset = async () => {
    await this.setState(s => ({ form: { ...s.form, ...initialForm } }));
    this.props.submitted(this.state.form);
  }

  render() {

    const { form, dates } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <div className="row">
          <div className="col-2">
            <Input
              color=" "
              name="search"
              label="N° de cierre"
              className="filter"
              value={form.search}
              onChange={e => this.handleChange(e.target.value, 'search')}
            />
          </div>

          <div className="col-2">
            <DatePicker
              color="white"
              label="Desde"
              className="filter"
              minDate={dates.minDate}
              value={form.since}
              onChange={value => this.handleChange(value, 'since')}
            />
          </div>

          <div className="col-2">
            <DatePicker
              color="white"
              label="Hasta"
              className="filter"
              maxDate={dates.maxDate}
              value={form.until}
              onChange={value => this.handleChange(value, 'until')}
            />
          </div>

          <div className="col-md">
            <Button color=" " className="btn-align-bottom btn-filter blue mr-3">
              <span>Filtrar</span>
            </Button>
            <Button color=" " className="btn-align-bottom btn-filter" type="button" onClick={this.reset}>
              <span>Limpiar</span>
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

export default Filter;
